import Image from 'next/image';

type props = {
  className: string;
  onClick: () => void;
  children: React.ReactNode;
  ariaControls?: string;
  ariaExpanded?: boolean;
};

export const PEIButton = ({
  children,
  onClick,
  ariaExpanded = true,
  ariaControls = '',
  className,
}: props) => {
  return (
    <button
      className={className}
      aria-controls={ariaControls}
      aria-expanded={ariaExpanded}
      onClick={onClick}
    >
      {children}
    </button>
  );
};
